module.exports = __webpack_public_path__ + "static/media/airlines.9ef14eef.webp";